import { useStaticQuery, graphql } from "gatsby"

const useIndustryExpertsBlogs = () => {
  const query = useStaticQuery(graphql`
  query industryBlogs {
    posts: allGhostPost(
        filter: { tags: { elemMatch: { slug: { eq: "industry-experts" } } } }
        sort: { order: DESC, fields: [published_at] }
        limit: 1000
        skip: 0
    ) {
        edges {
            node {
                id
                title
                slug
                feature_image
                excerpt
                published_at(formatString: "DD MMMM YYYY")
                primary_author {
                    name
                    slug
                    profile_image
                }
                tags {
                    name
                    slug
                }
            }
        }
    }
  }
  `);

  return query;
}

export default useIndustryExpertsBlogs;
